import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const laboratoryPersonnelsApi = {
    getLaboratoryPersonnels: (): Observable<Dtos.GetLaboratoryPersonnelsResponse> => {
        //Create the request.
        let request: Dtos.GetLaboratoryPersonnels = new Dtos.GetLaboratoryPersonnels();

        //Send request.
        const response: Promise<Dtos.GetLaboratoryPersonnelsResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getLaboratoryPersonnelById: (id: number): Observable<Dtos.GetLaboratoryPersonnelByIdResponse> => {
        //Create the request.
        let request: Dtos.GetLaboratoryPersonnelById = new Dtos.GetLaboratoryPersonnelById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetLaboratoryPersonnelByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getLaboratoryPersonnelByLaboratoryId: (laboratoryId: number): Observable<Dtos.GetLaboratoryPersonnelByLaboratoryIdResponse> => {
        //Create the request.
        let request: Dtos.GetLaboratoryPersonnelByLaboratoryId = new Dtos.GetLaboratoryPersonnelByLaboratoryId();

        request.laboratoryId = laboratoryId;

        //Send request.
        const response: Promise<Dtos.GetLaboratoryPersonnelByLaboratoryIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setLaboratoryPersonnel: (laboratoryPersonnel: Dtos.LaboratoryPersonnel): Observable<Dtos.SetLaboratoryPersonnelResponse> => {

        let request: Dtos.SetLaboratoryPersonnel = new Dtos.SetLaboratoryPersonnel();

        request.laboratoryPersonnel = laboratoryPersonnel;

        // send request
        const response: Promise<Dtos.SetLaboratoryPersonnelResponse> = client.post(request);

        return Observable.from(response);

    },
    createLaboratoryPersonnel: (laboratoryId: number): Observable<Dtos.CreateLaboratoryPersonnelResponse> => {
        //Create the request.
        let request: Dtos.CreateLaboratoryPersonnel = new Dtos.CreateLaboratoryPersonnel();

        request.laboratoryId = laboratoryId;

        //Send request.
        const response: Promise<Dtos.CreateLaboratoryPersonnelResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateLaboratoryPersonnel: (laboratoryPersonnel: Dtos.LaboratoryPersonnel): Observable<Dtos.ValidateLaboratoryPersonnelResponse> => {

        let request: Dtos.ValidateLaboratoryPersonnel = new Dtos.ValidateLaboratoryPersonnel();

        request.laboratoryPersonnel = laboratoryPersonnel;

        // send request
        const response: Promise<Dtos.ValidateLaboratoryPersonnelResponse> = client.post(request);

        return Observable.from(response);

    }
}